const SearchIcon = () => {
  return (
    <svg
      className="icon-search"
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
    >
      <g clip-path="url(#clip0_22_119)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.28572 3.85714C1.28572 3.17516 1.55664 2.5211 2.03887 2.03887C2.52111 1.55663 3.17516 1.28571 3.85715 1.28571C4.53913 1.28571 5.19319 1.55663 5.67542 2.03887C6.15766 2.5211 6.42858 3.17516 6.42858 3.85714C6.42858 4.53913 6.15766 5.19318 5.67542 5.67542C5.19319 6.15765 4.53913 6.42857 3.85715 6.42857C3.17516 6.42857 2.52111 6.15765 2.03887 5.67542C1.55664 5.19318 1.28572 4.53913 1.28572 3.85714ZM3.85715 7.29395e-08C3.2501 -7.73934e-05 2.6516 0.143127 2.11034 0.417967C1.56907 0.692807 1.10032 1.09152 0.742199 1.58168C0.384081 2.07184 0.146712 2.63961 0.049397 3.23881C-0.0479182 3.838 -0.00243131 4.45171 0.182158 5.03001C0.366747 5.60831 0.685227 6.13488 1.11169 6.56689C1.53816 6.9989 2.06058 7.32415 2.63645 7.51619C3.21232 7.70823 3.82538 7.76164 4.42579 7.67207C5.02619 7.58249 5.59697 7.35247 6.09172 7.00071L7.90265 8.81164C8.02389 8.92874 8.18628 8.99354 8.35483 8.99208C8.52339 8.99061 8.68463 8.923 8.80382 8.80381C8.92301 8.68462 8.99062 8.52338 8.99208 8.35483C8.99355 8.18627 8.92875 8.02389 8.81165 7.90264L7.00136 6.09236C7.41168 5.5153 7.65525 4.83644 7.70537 4.13015C7.75548 3.42386 7.61022 2.7174 7.28549 2.08819C6.96076 1.45898 6.46909 0.931299 5.86437 0.562965C5.25965 0.194632 4.56521 -0.000137604 3.85715 7.29395e-08Z"
          fill="#ffffffff"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_119">
          <rect width="9" height="9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchIcon;
